import { EventEmitter, Injectable } from '@angular/core';

import { OrganizationControllerService } from '@scip/api';
import { DossierDefaultsDto } from '@scip/api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DossierDefaultsService {
  actionPreferenceEmitter: EventEmitter<string> = new EventEmitter();

  constructor(private organizationControllerService: OrganizationControllerService) {}

  brodcastActionPreferences(action: string): void {
    this.actionPreferenceEmitter.emit(action);
  }

  retrievePreferences(): Observable<DossierDefaultsDto> {
    return this.organizationControllerService.getGlobalDossierDefaults();
  }

  updatePreferences(pref: DossierDefaultsDto): Observable<DossierDefaultsDto> {
    return this.organizationControllerService.updateGlobalDossierDefaults(pref);
  }
}
